import { FormattedMessage } from 'react-intl'

export const resortSteps = [
  {
    text: (
      <FormattedMessage
        id='select_your_package'
        defaultMessage='Select your package'
      />
    ),
    shortText: <FormattedMessage id='package' defaultMessage='Package' />,
  },
  {
    text: <FormattedMessage id='add_extras' defaultMessage='Add Extras' />,
    shortText: <FormattedMessage id='extras' defaultMessage='Extras' />,
  },
  {
    text: (
      <FormattedMessage id='review_and_book' defaultMessage='Review & book' />
    ),
    shortText: <FormattedMessage id='review' defaultMessage='Review' />,
  },
]
